export interface PosterCaptionState {
  propertyLabel: string;
  profileName: string;
  colourName: string;
  dateIso: string;
  disclaimer: string;
}

export const POSTER_WIDTH = 1600;
export const POSTER_HEIGHT = 900;
export const POSTER_DISCLAIMER = "Indicative digital view. Confirm final product and colour with physical samples and your roofing team.";

export function posterCaptionState(
  propertyLabel: string,
  profileName: string,
  colourName: string,
  now = new Date(),
): PosterCaptionState {
  return {
    propertyLabel,
    profileName,
    colourName,
    dateIso: now.toISOString().slice(0, 10),
    disclaimer: POSTER_DISCLAIMER,
  };
}
